import { ChangeEvent } from 'react'

import { setFieldset } from '@/zustand/stores/price-range/usePriceRangeStore'

function setRange(
  event: ChangeEvent<HTMLInputElement>,
  range: number[],
  max: number
) {
  const [priceFrom, priceTo] = range
  const { name, value } = event.target

  const newPrice = Number(value) || 0

  let newRange: number[]

  if (name === 'price_from') {
    const value = newPrice > priceTo ? priceTo : newPrice
    setFieldset([newPrice, priceTo])

    newRange = [value, priceTo]
  } else {
    const value =
      newPrice < priceFrom ? priceFrom : newPrice > max ? max : newPrice
    setFieldset([priceFrom, newPrice])

    newRange = [priceFrom, value]
  }

  return newRange
}

export default setRange
